import React, {useContext, useEffect} from "react";
import {Typography, Space, Button} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import "./style.scss";
// core
import {LayoutContext, ModalContext} from "../../../core/Contexts";
//images
import attention from "../../../images/attention_sessions.png";
import {useNavigate, useParams} from "react-router-dom";
import Store from "../../../stores";
import {IReservations} from "../../../core/models/Reservations";

export default React.memo(function AgreementImportantModal({
    tariffId,
    phone_number,
    reservations,
    signUrl
}: IProps) {
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);
    const params = useParams();
    const navigate = useNavigate();
    const onClick = () => {
        const url = new URL(signUrl);
        // navigate(`${url?.pathname}${location.search ?? ""}`);
        navigate(`${url?.pathname}?id=${tariffId}&phone=${phone_number}`);
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    return (
        <Typography as="div" className="bl-important">
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 32 : 18}
                direction="vertical"
                align="center"
            >
                {_.gte(contextLayout?.width ?? 0, 768) ? (
                    <img src={attention} width={70} alt="attention" />
                ) : (
                    <img src={attention} width={52} alt="attention" />
                )}

                <Typography as="div" className="title">
                    Важно!
                </Typography>
                {_.gte(contextLayout?.width ?? 0, 768) ? (
                    <Typography as="div" className="text">
                        {
                            "Клиент должен лично подписать договор в Вашем \nприсутствии в течении 10 дней после пополнения баланса!"
                        }
                    </Typography>
                ) : (
                    <Typography as="div" className="text">
                        {
                            "Клиент должен лично подписать договор в Вашем \nприсутствии в течении 10 дней после пополнения баланса!"
                        }
                    </Typography>
                )}
                <Typography as="div" className="content-subtitle">
                    <Typography as="div" className="subtitle">
                        {
                            "Проверьте правильность заполнения всех данных клиента \nперед подписанием договора!"
                        }
                    </Typography>
                </Typography>

                <Button type="primary" onClick={onClick}>
                    Подписать договор
                </Button>
            </Space>
        </Typography>
    );
});

interface IProps {
    tariffId?: any;
    phone_number?: any;
    reservations?: IReservations;
    signUrl: string;
}
